import { UserRoles } from '@gettactic/api';
import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export function useUserList(
  query: string | null = null,
  roles: UserRoles[] | null = null,
  cursor: string | null = null,
  managed = false
) {
  const { api } = useTacticHooks();
  return useQuery({
    queryKey: ['organizations.usersWithOptions', query, roles, cursor, managed],

    queryFn: async () => {
      const res = await api.client.organizations.usersWithOptions(
        query,
        roles,
        {
          cursor,
          limit: null
        },
        managed
      );
      return res.result;
    }
  });
}
